import LinkRootBlocks from '../../../components/blocks/LinkRootBlocks.jsx';
import ROUTES from '../../../routes/Routes.js';

export default function LinkrootCompany() {
    return (
        <LinkRootBlocks
            maintitle="¿Qué acción deseas realizar?"
            columnsPerRow={2}
            blocks={[
                { ico: "bi bi-building-add", title: "Crear nueva empresa", link: ROUTES.CREATE_COMPANY},
                { ico: "bi bi-list-task", title: "Lista de empresas", link: ROUTES.LIST_COMPANY},
            ]}
        />
    );
}